import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Avatar } from '@mui/material';

import { ANNOUNCEMENTS } from 'types/announcements';
import { AppDispatch } from 'redux/store';
import Icon from 'assets/icon.png';
import { setAnnouncementsTab } from 'redux/slices/common/appSlice';
import Routes from 'constants/routes';

const drawerWidth = 2;
interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    zIndex: theme.zIndex.drawer + 1,
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

interface AppBarComponentProps {
    open: boolean;
    handleDrawerOpen: () => void;
    handleDrawerClose: () => void;
}
export default function AppBarComponent({ open, handleDrawerOpen, handleDrawerClose }: AppBarComponentProps) {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const navigationHandler = () => {
        if (open) {
            handleDrawerClose();
        } else {
            handleDrawerOpen();
        }
    };

    const handleNotificationClick = async () => {
        dispatch(setAnnouncementsTab(ANNOUNCEMENTS));
        navigate(Routes.announcements.main);
    };

    return (
        <AppBar color="inherit" position="fixed" open={open}>
            <Toolbar sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={navigationHandler}
                    edge="start"
                    sx={{ mr: 2, ...(open && {}) }}
                >
                    <MenuIcon />
                </IconButton>

                <IconButton>
                    <Avatar style={{}} sx={{ width: 40, height: 40 }} src={Icon} alt="User Avatar" />
                </IconButton>

                <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                    Catholic Community
                </Typography>
                <IconButton onClick={handleNotificationClick}>
                    <NotificationsIcon htmlColor="black" />
                </IconButton>
            </Toolbar>
        </AppBar>
    );
}
